import React, { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
  Typography,
  Divider,
  Box,
} from "@mui/material";

const DEFAULT_ACK_TEXT =
  "I agree to receive updates, promotional emails, and messages from CII Young Indians.";

export default function PrivacyPolicyModal({
  open,
  onAccept,
  title = "Privacy Policy",
  body,
  ackText = DEFAULT_ACK_TEXT,
}) {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (open) setChecked(false);
  }, [open]);

  const effectiveBody = useMemo(() => {
    if (body) return body;
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
        <Typography variant="body2" color="text.secondary">
          Before continuing, please review and acknowledge our privacy notice.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          By accepting, you consent to being contacted with updates and promotional
          information related to the portal and CII Young Indians.
        </Typography>
      </Box>
    );
  }, [body]);

  return (
    <Dialog
      open={!!open}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      onClose={() => {
        // Intentionally block closing until accepted
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {effectiveBody}
        <Divider sx={{ my: 2 }} />
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
          }
          label={<Typography variant="body2">{ackText}</Typography>}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          variant="contained"
          onClick={() => onAccept?.()}
          disabled={!checked}
        >
          Accept & Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}

